import { OnlineSales } from 'gw-edge-client';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { externalCasesAtom } from '../atoms/externalCasesAtom';
import { useAsyncThrow } from '../../hooks/useAsyncThrow';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const useSaveAllEdi = (): {
    saveData: () => Promise<void>;
    isWaiting: boolean;
} => {
    const [isWaiting, setIsWaiting] = useState(false);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const externalCases = useRecoilValue(externalCasesAtom);
    const { asyncThrow } = useAsyncThrow();

    const saveData = async (): Promise<void> => {
        try {
            setIsWaiting(true);
            await OnlineSales.saveAllEdi(jobNumber, sessionId, {}, externalCases);
            setIsWaiting(false);
        } catch (err) {
            setIsWaiting(false);

            if (err instanceof Error) {
                asyncThrow(err);
            }
        }
    };

    return { saveData, isWaiting };
};
